export default "__VITE_ASSET__DScZudtl__"